import Icona from 'components/3catinfo/ui/Icona';
import Enllac from 'components/3catinfo/Enllac';
import { useViewport } from 'hooks/3catinfo/useViewport';
import clsx from 'clsx';
import styles from './previsioRecents.module.scss';

const ItemPrevisioRecent = (props) => {
    const { id, nom, min, max, icona, text, cercaRecent } = props;
    const { zoomNavigator } = useViewport();

    const stylesCard = clsx({
        [styles.cardPrevisio]: true,
        [styles.cercaRecent]: !!cercaRecent,
        [styles.ambZoom]: zoomNavigator > 3
    });

    return (
        <Enllac
            className={styles.enllacPrevisio}
            type='web_3catinfo_el_temps_municipi'
            slug={nom}
            id={id}
            title={`Previsió del temps a ${nom}`}
        >
            <div className={stylesCard}>
                <div className={styles.contentInfo}>
                    <div className={styles.info}>
                        <span className={styles.poblacio}>{nom}</span>
                        <p className={styles.text}>{text}</p>
                    </div>
                    <Icona className={styles.icona} path='el-temps' isBlanc={true} icona={icona} mida={56} />
                </div>
                <div className={styles.contentInfoSub}>
                    <div className={styles.contentTemperatures}>
                        <div className={`${styles.temp} ${styles.tempMax}`}>{max}º</div>
                        <div className={`${styles.temp} ${styles.tempMin}`}>{min}º</div>
                    </div>
                    {cercaRecent && <span className={styles.textCercaRecent}>CERCA RECENT</span>}
                </div>
            </div>
        </Enllac>
    );
};

export default ItemPrevisioRecent;
